"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = require("react");
const uuid_1 = require("uuid");
const useUniqueId = (defaultId) => {
    const { current: uniqueId } = react_1.useRef(defaultId !== null && defaultId !== void 0 ? defaultId : uuid_1.v4());
    return uniqueId;
};
exports.default = useUniqueId;
//# sourceMappingURL=index.js.map